import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
    DropdownNestedOption,
    DropdownWrapper,
    DropdownOptionButton,
    IconShutdown,
} from '@trqk/components';
import { getEnableControlPanel } from '@trqk/utils';

import { PATHS } from '../../../../constants';

interface AdminToolsProps {
    height: number;
    width: number;
}

const enableControlPanel = getEnableControlPanel();

export const AdminTools = ({ height, width }: AdminToolsProps): JSX.Element => {
    const history = useHistory();
    const [isExpanded, setIsExpanded] = useState(true);

    return (
        <DropdownNestedOption
            height={height}
            label="Admin Tools"
            width={width}
            Icon={IconShutdown}
        >
            <DropdownWrapper
                borderConfig="none"
                closeOnClickOutside={false}
                disabled={false}
                height={height}
                isExpanded={isExpanded}
                selectedLabel=""
                setIsExpanded={setIsExpanded}
                showToggle={false}
                width={width}
            >
                <DropdownOptionButton
                    handleClick={(): void => {
                        history.push({
                            search: history.location.search,
                            pathname: PATHS.CLIENT_EVENTS,
                        });
                    }}
                    height={height}
                    label="Client Events"
                />
                {enableControlPanel && (
                    <DropdownOptionButton
                        handleClick={(): void => {
                            history.push({
                                search: history.location.search,
                                pathname: PATHS.CONTROL_PANEL,
                            });
                        }}
                        height={height}
                        label="Control Panel"
                    />
                )}
            </DropdownWrapper>
        </DropdownNestedOption>
    );
};
